module.exports = __webpack_public_path__ + "static/img/cover.e794ad8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_6/cover.jpg
// module id = 8wNK
// module chunks = 0